import { NgModule } from '@angular/core';
import { Tr3Module } from '@trilean/tr3';
import { Tr3MaterialModule } from './tr3-material.module';
import { Tr3MaterialSharedCdkModule } from './tr3-material-shared-cdk.module';
import { Tr3MaterialSharedMatModule } from './tr3-material-shared-mat.module';

const sharedModules = [Tr3Module, Tr3MaterialModule, Tr3MaterialSharedCdkModule, Tr3MaterialSharedMatModule];

@NgModule({
  imports: sharedModules,
  exports: sharedModules,
})
export class Tr3MaterialSharedAllModule {}
